module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_styled_03-067350e1c858c32644060d35b786829c.jpg";